// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"6794a136","498":"71d2491c","598":"ee4f9a94"}[chunkId] + ".chunk.js";
};